/**
 *  @fileOverview Custom dropdown select controller
 *
 *  @author       Peter Schmiz <peter.schmiz@possible.com>
 *
 *  @requires     NPM:lodash
 */

import forEach from 'lodash/forEach';
import CustomSelect from './custom-select';

class CustomSelectController {
  constructor() {
    this.customSelects = [];
  }

  init() {
    this.initCustomSelects();
  }

  initCustomSelects() {
    forEach(document.querySelectorAll('[data-custom-select]'), (elem) => {
      this.customSelects.push({
        name: elem.getAttribute('data-custom-select').toLowerCase(),
        select: new CustomSelect(elem),
      });
    });
  }

  getSelectByName(name) {
    const result = this.customSelects.filter(select => (select.name === name));

    if (result && result[0] && result[0].select) {
      return result[0].select;
    }
    return null;
  }
}

export const customSelectController = new CustomSelectController();



// WEBPACK FOOTER //
// ./src/js/modules/custom-select-controller.js